
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Artist from "@/models/artist";
import Artwork from "@/models/artwork";
import ScaleDisplayer from "@/components/ScaleDisplayer.vue";
import SmallScaleDisplayer from "@/components/SmallScaleDisplayer.vue";
import BackButton from "@/components/BackButton.vue";

const namespace = "ArtistViewModule";

@Component({
  components: {
    ScaleDisplayer,
    BackButton,
    SmallScaleDisplayer
  },
  metaInfo: {
    title: 'Color Scales',
    titleTemplate: 'Color Scales',
  }
})

export default class ArtistView extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: (id: string) => any;
  @Action('fetchData', { namespace: 'MuseumModule' }) private fetchMuseumData!: () => any;
  @Getter ("getBirthYear", { namespace }) private getBirthYear!: string;
  @Getter ("getDeathYear", { namespace }) private getDeathYear!: string;
  @Getter ("getSortedArtworks", { namespace }) private sortedArtworks!: Artwork[];
  @Mutation ("setDisplayingImageURL", { namespace }) private setDisplayingImageURL!: (artwork:Artwork) => any;
  @Mutation ("setDisplayingBigImage", { namespace }) private setDisplayingBigImage!: (value:boolean) => any;
  @State ("artist", { namespace }) private artist!: Artist;
  @State ("loading", { namespace }) private loading!: boolean;
  @State ("artistArtworks", { namespace }) private artistArtworks!: Artist;
  @State ("displayingImage", { namespace }) private displayingImage!: Artwork;
  @State ("displayingBigImage", { namespace }) private displayingBigImage!: boolean;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private created(){
    this.fetchData(this.$route.params.id);
    this.fetchMuseumData();
    this.setDisplayingBigImage(false);
  }

  private handleImageClick(artwork: Artwork){
    this.setDisplayingImageURL(artwork);
    this.setDisplayingBigImage(true);
  }

  private handleCloseImageClick(){
    this.setDisplayingBigImage(false);
  }
};
